/**
 * @type {import('blockly')} Blockly
 */
let _blockly;
/**
 * Provide a function which will load the Blockly dependency.
 * See issue https://github.com/google/blockly/issues/4369
 * Blockly will not allow you to avoid printing out a bunch of useless
 * localization warnings for messages we don't use.
 * This clogs up unit testing logs, etc.
 * The versions for both log and warn are because they keep changing which ones they are
 * using across builds.
 */
function initializeBlockly() {
    /* eslint-disable */
    const tempConsoleLog = console.log;
    const tempConsoleWarn = console.warn;
    try {
        console.log = message => {
            if (message.startsWith('WARNING: No message string for %{')) return;
            else tempConsoleLog(message);
        };
        console.warn = message => {
            if (message.startsWith('No message string for %{')) return;
            else tempConsoleWarn(message);
        };
        _blockly = require('blockly');
    } finally {
        console.log = tempConsoleLog;
        console.warn = tempConsoleWarn;
    }
    // ******************************************************************************
    /* eslint-enable */
}

initializeBlockly();
module.exports = {
    blockDefinition: require('./blockDefinition'),
    getMetaDataFromWorkspace: require('./utilities/metadataFromWorkspace'),
    configureWorkspace: require('./blockDefinition/blocklyWorkspace').configureWorkspace,
    testTools: require('../test/testSetup'),
    Blockly: _blockly
};
